import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'ui/i18n';

import './PromotionBreadcrumb.scss';

export default class PromotionBreadcrumb extends Component {
	static propTypes = {
		promotionName: PropTypes.string.isRequired,
		categoryName: PropTypes.string.isRequired,
		itemDetails: PropTypes.object,
	};

	static defaultProps = {
		itemDetails: null,
	};

	render() {
		const { promotionName, categoryName, itemDetails } = this.props;

		return (
			<div className="PromotionBreadcrumb">
				<Link to="/">
					<FormattedMessage id="navigation.home" />
				</Link>{' '}
				{` > `}
				{itemDetails
					? <div>
							<Link
								to={`/offerings?categoryId=${itemDetails.category_id}&promotionId=${itemDetails.promotion_id}`}
							>
								{`${promotionName} > ${categoryName}`}
							</Link>
							{` > `}
							<span>
								{itemDetails.name}
							</span>
						</div>
					: <p>{`${promotionName} > ${categoryName}`}</p>}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/PromotionBreadcrumb/index.js